import { AuthRepository } from '../repositories/auth_repository';
import { TokenEntity } from '../entities/token_entity';

/**
 * Caso de uso para verificar token persistido
 */
export class GetPersistedTokenUseCase {
  constructor(private authRepository: AuthRepository) {}

  async execute(): Promise<TokenEntity | null> {
    try {
      const token = await this.authRepository.getPersistedToken();
      
      if (!token) {
        return null;
      }

      // Verifica se o token ainda é válido
      if (!this.authRepository.isTokenValid(token)) {
        await this.authRepository.persistToken(null);
        return null;
      }

      return token;
    } catch (error) {
      console.error('Error getting persisted token:', error);
      return null;
    }
  }
}
